<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <HistoricoAlteracaoList :id="id"></HistoricoAlteracaoList>
    </b-modal>
</template>

<script>

import HistoricoAlteracaoList from '@/modules/patrimonio/historico-alteracao/HistoricoAlteracaoList.vue';

export default {
    name: "ModalHistoricoAlteracaoList",
    components: {
        HistoricoAlteracaoList
    },
    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },

        title: {
            tipe: String,
            default: "Histórico",
        },

    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>